/// Provides form locking during promise resolution.
const Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
    initialize: function() {
        this.view.lockFormOn = function(promise) {
            this.triggerMethod('lockForm');
            promise.always(function() {
                this.triggerMethod('unlockForm');
                this.triggerMethod('afterUnlockForm');
            }.bind(this));
            return promise;
        };
    },
    onLockForm: function() {
        let controls = this._getControlsForLock();
        controls.prop('disabled', true);
        // Set this attribute to mark what was locked by this behavior, so we
        // know what to unlock when promise resolves.
        controls.attr('data-lockForm', true);
    },
    onUnlockForm: function() {
        let controls = this._getControlsForUnlock();
        controls.prop('disabled', false);
        controls.removeAttr('data-lockForm')
    },
    _getControlsForLock: function() {
        // We don't need to lock anything that's already disabled.
        let result = null;
        let controls = this.$el.find('.btn, input, select, textarea');
        // Note that this filter() method is from jQuery, not underscore.
        // Note: our version of jQuery ignores arrow functions.
        result = controls.filter(function() {
            return !$(this).hasClass('disabled') && $(this).prop('disabled') === false;
        })
        return result;
    },
    _getControlsForUnlock: function() {
        // We only return the controls explicitly marked as locked by this behavior.
        return this.$el.find('[data-lockForm="true"]');
    }
});
